import { render, staticRenderFns } from "./queryResultStyle.vue?vue&type=template&id=6b973724&scoped=true"
import script from "./queryResultStyle.vue?vue&type=script&lang=js"
export * from "./queryResultStyle.vue?vue&type=script&lang=js"
import style0 from "./queryResultStyle.vue?vue&type=style&index=0&id=6b973724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b973724",
  null
  
)

export default component.exports